import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/constants';
import productService from '@/services/product.service';
import type { SetAdminProductContextPayload } from '@/types';

export const useSetAdminProductContextMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: SetAdminProductContextPayload) => productService.setAdminProductContext(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.ADMIN_PRODUCT_CONTEXT] });
    },
  });
};
